import styled from 'styled-components';
import MessageFeedbackButtons from './MessageFeedbackButtons';
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SourcesAndFeedbackRow = styled.div.withConfig({
  displayName: "SourcesAndFeedback__SourcesAndFeedbackRow"
})(["display:flex;align-items:center;gap:8px;width:100%;"]);
const FeedbackButtonsWrapper = styled.div.withConfig({
  displayName: "SourcesAndFeedback__FeedbackButtonsWrapper"
})(["flex-shrink:0;"]);
function SourcesAndFeedback({
  sourcesContent,
  showFeedback,
  selectedFeedback,
  onFeedbackClick
}) {
  if (!sourcesContent && !showFeedback) {
    return null;
  }
  return /*#__PURE__*/_jsx(PrimaryMessageFooter, {
    children: /*#__PURE__*/_jsxs(SourcesAndFeedbackRow, {
      children: [showFeedback && /*#__PURE__*/_jsx(FeedbackButtonsWrapper, {
        children: /*#__PURE__*/_jsx(MessageFeedbackButtons, {
          onFeedbackClick: onFeedbackClick,
          selectedFeedback: selectedFeedback
        })
      }), sourcesContent]
    })
  });
}
SourcesAndFeedback.displayName = 'SourcesAndFeedback';
export default SourcesAndFeedback;